module.exports = __webpack_public_path__ + "img/7c9e2ee.svg";